module.exports = __webpack_public_path__ + "static/img/solution (2).cb950466.png";